import { useEffect, useState } from "react";
import { getWishlist, removeFromWishlist } from "../services/wishlist";
import { useAuthUser } from "../hooks/useAuthUser";
import MovieCard from "../components/MovieCard";

function Wishlist() {
  const user = useAuthUser();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!user?.id) return;
    getWishlist(user.id).then(setItems);
  }, [user]);

  if (!user) return null;

  return (
    <div className="wishlist-page">
      <h2 className="wishlist-title">My Wishlist</h2>

      {items.length === 0 ? (
        <div className="wishlist-empty">
          No items in your wishlist
        </div>
      ) : (
        <div className="wishlist-grid">
          {items.map((movie) => (
            <MovieCard
              key={movie.id}
              movie={{
                ...movie,
                poster_path: movie.poster, // 🔑 Firestore → TMDB format
              }}
              showRemove
              onRemove={async (id) => {
                await removeFromWishlist(user.id, id);
                setItems((prev) =>
                  prev.filter((m) => m.id !== id)
                );
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default Wishlist;
